import React, { memo, useCallback, useMemo } from 'react'
import { IAIImageModel } from 'store/types/aiImage'
import { isPremiumModel } from 'utils'
import {
  GroupedModelList,
  IModelGroup,
  IDropdownModel
} from 'containers/SubSidebar/shared/GroupedModelDropdown'
import { AI_IMAGE_MODEL_GROUP_META } from './consts'
import { getImageCapabilityLabels, getImageGroupKey } from './utils'

interface IProps {
  models: IAIImageModel[]
  selectedModelCode: string | null
  onSelect: (modelCode: string) => void
  userCurrentPlanId: number
  onInnerSlideUpOpenChange?: (open: boolean) => void
}

const ModelDropdownContent: React.FC<IProps> = ({
  models: inputModels,
  selectedModelCode,
  onSelect,
  userCurrentPlanId,
  onInnerSlideUpOpenChange
}) => {
  const models = useMemo<IDropdownModel[]>(
    () =>
      inputModels.map(m => ({
        id: m.id,
        name: m.name,
        selectKey: m.code,
        groupKey: getImageGroupKey(m),
        order: m.order,
        isPremium: isPremiumModel(m, userCurrentPlanId),
        capabilityLabels: getImageCapabilityLabels([m])
      })),
    [inputModels, userCurrentPlanId]
  )

  const getGroupLabels = useCallback(
    (group: IModelGroup) =>
      getImageCapabilityLabels(
        inputModels.filter(m => getImageGroupKey(m) === group.key)
      ),
    [inputModels]
  )

  const handleSelect = (model: IDropdownModel) => onSelect(model.selectKey)

  return (
    <GroupedModelList
      models={models}
      selectedKey={selectedModelCode}
      groupMeta={AI_IMAGE_MODEL_GROUP_META}
      onSelect={handleSelect}
      getGroupLabels={getGroupLabels}
      onInnerSlideUpOpenChange={onInnerSlideUpOpenChange}
    />
  )
}

export default memo(ModelDropdownContent)
